<div *ngIf="hasAccess" class="content-wrapper py-3">
    <div class="pb-3 pl-2 text-center" #container>
        <button class="btn-clipboard" (click)="promptToaster()" ngxClipboard [cbContent]="walletAddress" [container]="container">
            {{walletAddress}}
            <span><i class="far fa-clone"></i></span>
        </button>
    </div>
    <app-asset-listing [params]="assetParams" [currentPage]="'user'"></app-asset-listing>
</div>
